export interface CartProductCombination {
    Type: ProductCombinationType;
    Includes: CartProductCombinationIncludes;
}

export interface CartProductCombinationIncludes {
    Flight: boolean;
    Ferry: boolean;
    Hotel: boolean;
    Activity: boolean;
}

export interface BookingProductCombination {
    type: ProductCombinationType;
    includes: BookingProductCombinationIncludes;
}

export interface BookingProductCombinationIncludes {
    flight: boolean;
    ferry: boolean;
    hotel: boolean;
    activity: boolean;
}

export enum ProductCombinationType {
    // Single products
    Flight = 'Flight',
    Ferry = 'Ferry',
    Hotel = 'Hotel',
    Activity = 'Activity',

    // Combinations of two products
    HotelFlight = 'HotelFlight',
    HotelFerry = 'HotelFerry',
    HotelActivity = 'HotelActivity',
    FlightFerry = 'FlightFerry',
    FlightActivity = 'FlightActivity',
    FerryActivity = 'FerryActivity',

    // Combinations of three products
    HotelFlightFerry = 'HotelFlightFerry',
    HotelFlightActivity = 'HotelFlightActivity',
    HotelFerryActivity = 'HotelFerryActivity',
    FlightFerryActivity = 'FlightFerryActivity',

    // Combination of all four products
    HotelFlightFerryActivity = 'HotelFlightFerryActivity',
}
